import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";
import { UpdateKeyValueRequest } from "@models/base/updateKeyValueRequest.model";

class TimeSpan {
  horas: number;
  minutos: number;
  segundos: number;

  constructor(horas: number = 0, minutos: number = 0, segundos: number = 0) {
    this.horas = horas;
    this.minutos = minutos;
    this.segundos = segundos;
  }
}

export class UpdateEventoAgendaRequest extends UpdateKeyValueRequest{

  titulo!: string;  // Título del evento (requerido, maxLength: 100, minLength: 0)
  fechaInicio!: string;  // Fecha de inicio en formato date-time (requerido)
  fechaAlta!: string;  // Fecha de alta en formato date-time (requerido)
  fechaFin!: string | null;  // Fecha de fin en formato date-time (nullable)
  horaInicio: string | null = null;
  horaFin: string | null = null;
  esTodoElDia!: boolean;  // Indica si es todo el día
  url!: string | null;  // URL del evento (nullable, maxLength: 200)
  classNames!: string | null;  // Clases CSS adicionales (nullable)
  esEditable!: boolean;  // Indica si el evento es editable
  colorFondo!: string | null;  // Color de fondo (nullable)
  colorBorde!: string | null;  // Color del borde (nullable)
  colorTexto!: string | null;  // Color del texto (nullable)
  asignadoA!: number | null;  // ID del usuario (requerido)
  idExpediente!: number | null;  // ID del expediente (nullable)
  prioridad!: number | null;  // Prioridad del evento (nullable)
  nivelAvance!: number | null;  // Nivel de avance del evento (nullable)
  comentarios!: string | null;  // Comentarios del evento (nullable, maxLength: 500)
  lugar!: string | null;  // Lugar del evento (nullable)
  recordatorio!: TimeSpan | null;  // Tiempo de recordatorio (nullable)
  esRecurrente!: boolean | null;  // Indica si el evento es recurrente (nullable)
  frecuenciaRecurrente!: string | null;  // Frecuencia recurrente (nullable, maxLength: 50)
  duracion!: TimeSpan | null;  // Duración del evento (nullable)
  idEstadoEventoAgenda!: number | null;  // Estado del evento (nullable)
  idTipoEventoAgenda!: number | null;  // Tipo de evento (nullable)
  esAvisoAPartes!: boolean;  // Indica si es un aviso a partes
  avisoNMinutosAntes!: number | null;  // Número de días antes para el aviso (nullable)
  diasSemana!: string;
  unidadRepeticion!: string;
  esEventoPresencial!: boolean;
  zonaHoraria!: string;
}
